module.exports = __webpack_public_path__ + "static/img/01.3fb32961.png";